<div class="flex my-4 items-center clickable-card-grid">
  <div
    class="mx-auto clickable-card w-full flex-col items-center justify-center cursor-pointer text-center px-3 {{
      reduced ? 'md:h-20' : 'md:h-36'
    }}"
    (mouseenter)="mouseEnter(item)"
    (mouseleave)="mouseLeave(item)"
    *ngFor="let item of responses"
    (click)="onItemSelected(item)"
    [ngClass]="setClassActive(item)">
    <p [innerHTML]="item.key"></p>
  </div>
</div>
